import React from 'react';
import { Typography, Box, InputField } from 'vindi-ds-components';
import useAdditionalFieldsHook from '../create/hooks/use_additional_fields';

const CustomFields = () => {
  const { customFields } = useAdditionalFieldsHook();

  if (customFields.length !== 0) {
    return (
      <Box display='flex' flexDirection='column' width='26.7em'>
        <Typography variant='subtitle1' component='h2'>
          Campos personalizados
        </Typography>
        {customFields.map(({ name, code }) => (
          <>
            <InputField name={`metadata_attributes.${code}`} label={`${name}(opcional)`} placeholder='Nome do campo' />
          </>
        ))}
      </Box>
    );
  }
  return null;
};

export default CustomFields;
